interface IconProps {
  color?: string;
  size?: string | number;
}

const PlayIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_272_878)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM15.225 12.445L11.251 15.857C11.1662 15.93 11.0622 15.9771 10.9514 15.9927C10.8405 16.0083 10.7276 15.9917 10.6259 15.945C10.5242 15.8982 10.4382 15.8232 10.3779 15.7289C10.3176 15.6346 10.2857 15.5249 10.286 15.413L10.286 8.58701C10.286 8.47519 10.318 8.3657 10.3782 8.27151C10.4385 8.17732 10.5245 8.10238 10.626 8.05555C10.7276 8.00872 10.8404 7.99198 10.9512 8.00731C11.0619 8.02263 11.166 8.06938 11.251 8.14201L15.225 11.555C15.2891 11.6101 15.3405 11.6784 15.3757 11.7552C15.411 11.832 15.4292 11.9155 15.4292 12C15.4292 12.0845 15.411 12.168 15.3757 12.2448C15.3405 12.3216 15.2891 12.3899 15.225 12.445Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_272_878">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlayIcon;
